import { observable, decorate, action } from 'mobx'

/**
 * Describes the store containing al info about notifier component for displaying toasts and other help messages.
 */
class NotifierStore {
    constructor() {
        /**
         * @Observable
         * @type {object}
         */
        this.showMessage = false
        this.toastInfo = {
            message: '',
            didSucceed: true,
        }
    }

    /**
     * @type {Function & IAction}
     */
    setShowMessage = action(show => {
        this.showMessage = show
    })

    /**
     * @type {Function & IAction}
     */
    setToastInfo = action((message, didSucceed) => {
        this.toastInfo = {
            message: message,
            didSucceed: didSucceed,
        }
    })
}

export default decorate(NotifierStore, {
    showMessage: observable,
    toastInfo: observable,
})
